<template>
    <v-card class="statisticsVerticalBarComponent pa-3 pt-0">
        <v-card-title>
            {{ $t("title_" + dataKey) }}
            <v-spacer></v-spacer>
            <v-select
                dense
                filled
                flat
                hide-details
                :items="frequencyOptions"
                v-model="selectedFrequency"
                @change="onFrequencyChange"
            />
        </v-card-title>
        <v-card-text class="chart-container">
            <v-skeleton-loader v-if="stats[dataKey] === undefined" type="article"></v-skeleton-loader>

            <div v-else-if="graphData.datasets && graphData.labels.length" class="chart-wrapper">
                <BarComponent :key="donutKey" :dataSet="graphData" :hideLegend="true" />
            </div>
            
            <v-alert class="mb-0" border="left" color="info" v-else text>
                {{ $t("emptyDataMessage") }}
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
import BarComponent from '@/components/graphs/BarComponent'

export default {
    name: "statisticsVerticalBarComponent",
    props: ["loadData", "stats", "dataKey"],
    components: { BarComponent },
    data() {
        return {
            frequencyOptions: [],
            selectedFrequency: 'weekly',
            donutKey: 0,
            graphData: {},
        }
    },
    watch: {
        stats: {
            handler() {
                this.generateGraphData(this.selectedFrequency);
            },
            deep: true,
        },
        loadData: {
            handler() {
                this.generateGraphData(this.selectedFrequency);
            },
        }
    },
    methods: {
        generateGraphData() {
            this.donutKey++;
            this.frequencyOptions = [];
            if(this.stats && this.stats[this.dataKey] !== undefined) {

                Object.keys(this.stats[this.dataKey]).forEach(frequency => {
                    this.frequencyOptions.push({
                        text: this.$t(frequency),
                        value: frequency
                    });
                });

                this.graphData = {
                    "datasets": [{
                        "data": this.stats[this.dataKey][this.selectedFrequency].map(obj => parseInt(obj.count)),
                        "backgroundColor": "#0058FE"
                    }],
                    "labels": this.stats[this.dataKey][this.selectedFrequency].map(obj => obj.label)
                }
            }
        },
        onFrequencyChange() {
            this.generateGraphData();
        }
    },
}
</script>

<style lang="scss">
    .statisticsVerticalBarComponent {
        
    }
</style>